/* IRIA conversion layer v4 — reveal, countdown, bundle cards, carousel,
   stock/ship urgency, count-up, social toasts, quiz, sign-up code reveal.
   Plain JS, no dependencies, reduced-motion aware. */
(function () {
  "use strict";
  var doc = document, win = window, root = doc.documentElement;
  root.classList.add("mv-js");
  var reduced = win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var CFG = win.MV_CONFIG || {};
  var money = function (p) { /* pence -> £x.xx (shop is GBP) */
    var s = (Math.round(p) / 100).toFixed(2);
    var sym = CFG.currencySymbol || "$";
    return sym + s;
  };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var pad = function (n) { return (n < 10 ? "0" : "") + n; };
  var ready = function (fn) { if (doc.readyState !== "loading") fn(); else doc.addEventListener("DOMContentLoaded", fn); };

  /* ------------------------------------------------------------ reveal */
  function initReveal() {
    var sel = ".mv-reveal, .bb-sec .bb-wrap, .bbhr, .quantity-breaks, .bb-receipt, .mv-supports, .ev-guarantee-box, .mv-h2, .mv-chiprow, .mv-cd, .mv-risk, .mv-statement, .bbrv-row, .mv-foot__col, .mv-stats__grid, .mv-faq, .mv-trustrow, .mv-shipline";
    var els = doc.querySelectorAll(sel);
    if (!els.length) return;
    els.forEach(function (e) { e.classList.add("mv-reveal"); });
    if (reduced || !("IntersectionObserver" in win)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------ countdown (Ryze) */
  /* One shared per-visitor timer: 15 min. On expiry every instance flips to
     "Need more time? We've extended your discount." and a fresh 10 min starts. */
  var CD_KEY = "mv_cd_v2", CD_FIRST = 107 * 60 * 1000, CD_NEXT = 93 * 60 * 1000;
  function cdState() {
    var s = store.get(CD_KEY), now = Date.now();
    if (!s || !s.end) { s = { end: now + CD_FIRST, ext: 0 }; store.set(CD_KEY, s); }
    return s;
  }
  function initCountdown() {
    var nodes = doc.querySelectorAll("[data-mv-cd]");
    if (!nodes.length) return;
    var s = cdState(), extAt = 0;
    function setExtended(on) {
      nodes.forEach(function (n) {
        n.classList.toggle("is-extended", on);
        var l = n.querySelector("[data-cd-label]"); if (!l) return;
        l.textContent = on ? (n.getAttribute("data-mv-cd-extended") || "Need more time? We've extended your discount.") : (n.getAttribute("data-mv-cd-label") || l.textContent);
      });
    }
    function paint() {
      s = cdState();
      var left = s.end - Date.now();
      if (left <= 0) {
        if (!extAt) { extAt = Date.now(); setExtended(true); return; }      /* show the "need more time" state for 4s */
        if (Date.now() - extAt > 4000) { s = { end: Date.now() + CD_NEXT, ext: (s.ext || 0) + 1 }; store.set(CD_KEY, s); extAt = 0; setExtended(false); }
        return;
      }
      var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), sec = Math.floor(left % 60000 / 1000);
      nodes.forEach(function (n) {
        var H = n.querySelector("[data-cd-h]"), M = n.querySelector("[data-cd-m]"), S = n.querySelector("[data-cd-s]"), T = n.querySelector("[data-cd-text]");
        if (H) { H.textContent = pad(h); if (H.parentNode) H.parentNode.style.display = h > 0 ? "" : "none"; }
        if (M) M.textContent = pad(m + h * 60);
        if (S) { S.textContent = pad(sec); if (!reduced) { S.classList.remove("tick"); void S.offsetWidth; S.classList.add("tick"); } }
        if (T) T.textContent = (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(sec);
      });
    }
    paint(); setInterval(paint, 1000);
  }

  /* ---------------------------------------------- bundle cards (mv-bcard) */
  function initBundles() {
    doc.querySelectorAll("[data-mv-bundles]").forEach(function (wrap) {
      var cards = wrap.querySelectorAll(".mv-bcard"), idInput = wrap.querySelector("input[name='id']"),
          qtyInput = wrap.querySelector("input[name='quantity']"),
          btnPrice = wrap.querySelector("[data-mv-atc-price]"), perday = wrap.querySelector("[data-mv-perday]"),
          saveEl = wrap.querySelector("[data-mv-save]");
      function apply(card) {
        cards.forEach(function (c) { c.classList.toggle("is-on", c === card); });
        var r = card.querySelector("input[type=radio]"); if (!r) return; r.checked = true;
        if (idInput) idInput.value = r.value;
        if (qtyInput) qtyInput.value = r.getAttribute("data-qty") || 1;
        if (btnPrice) btnPrice.textContent = money(+r.getAttribute("data-price"));
        if (perday) perday.textContent = r.getAttribute("data-perday") || "";
        if (saveEl) saveEl.textContent = r.getAttribute("data-save") || "";
        if (propInput) propInput.value = r.getAttribute("data-includes") || "";
        var bundleInput = wrap.querySelector("input[name='properties[Bundle]']");
        if (bundleInput) bundleInput.value = r.getAttribute("data-label") || "";
        var cardImg = card.querySelector(".mv-bcard__img img");
        wrap.dispatchEvent(new CustomEvent("mv:bundle", { detail: { id: r.value, price: +r.getAttribute("data-price"), imgSrc: cardImg ? cardImg.getAttribute("src") : "" }, bubbles: true }));
      }
      cards.forEach(function (c) {
        c.addEventListener("click", function () { apply(c); });
        c.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); apply(c); } });
      });
      var propInput = wrap.querySelector("input[name='properties[Includes]']");
      var on = wrap.querySelector(".mv-bcard input:checked");
      if (on) apply(on.closest(".mv-bcard")); else if (cards[1]) apply(cards[1]);
    });
  }

  /* ------------------------------------------------------------ carousel */
  function initCarousel() {
    doc.querySelectorAll("[data-mv-car]").forEach(function (car) {
      var track = car.querySelector(".mv-car__track"),
          thumbWrap = car.querySelector(".mv-car__thumbs"),
          prev = car.querySelector(".mv-car__nav--prev"),
          next = car.querySelector(".mv-car__nav--next");
      if (!track) return;
      var i = 0, timer, paused = false, autoplay = +(car.getAttribute("data-autoplay") || 0);

      function getSlides() { return track.querySelectorAll(".mv-car__slide"); }
      function getThumbs() { return thumbWrap ? thumbWrap.querySelectorAll(".mv-car__thumb") : []; }

      function go(k, smooth) {
        var slides = getSlides(), n = slides.length; if (!n) return;
        i = (k + n) % n;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduced ? "auto" : "smooth" });
        mark();
      }
      function mark() {
        getThumbs().forEach(function (t, k) { t.classList.toggle("is-on", k === i); t.setAttribute("aria-current", k === i ? "true" : "false"); });
      }
      function bindThumbs() {
        getThumbs().forEach(function (t, k) { t.addEventListener("click", function () { go(k); bump(); }); });
      }
      bindThumbs();
      if (prev) prev.addEventListener("click", function () { go(i - 1); bump(); });
      if (next) next.addEventListener("click", function () { go(i + 1); bump(); });
      var sc; track.addEventListener("scroll", function () { clearTimeout(sc); sc = setTimeout(function () { var slides = getSlides(), n = slides.length; if (!n) return; var k = Math.round(track.scrollLeft / slides[0].offsetWidth); if (k !== i) { i = (k + n) % n; mark(); } }, 80); }, { passive: true });
      function bump() { paused = true; clearTimeout(timer); setTimeout(function () { paused = false; loop(); }, 9000); }
      function loop() { if (!autoplay || reduced) return; clearTimeout(timer); timer = setTimeout(function () { if (!paused && doc.visibilityState === "visible") go(i + 1); loop(); }, autoplay); }
      car.addEventListener("mouseenter", function () { paused = true; }); car.addEventListener("mouseleave", function () { paused = false; });
      track.addEventListener("touchstart", function () { bump(); }, { passive: true });
      mark(); loop();

      /* --- swap first carousel slide to match selected bundle image --- */
      doc.addEventListener("mv:bundle", function (ev) {
        var src = ev.detail && ev.detail.imgSrc;
        if (!src) return;
        var firstSlide = track.querySelector(".mv-car__slide img");
        var firstThumb = thumbWrap ? thumbWrap.querySelector(".mv-car__thumb img") : null;
        if (firstSlide) firstSlide.src = src;
        if (firstThumb) firstThumb.src = src;
        go(0, false);
      });
    });
  }

  /* -------------------------------------------- stock + dispatch urgency */
  function initUrgency() {
    var stockEls = doc.querySelectorAll("[data-mv-stock]");
    if (stockEls.length) {
      var day = new Date().toDateString(), s = store.get("mv_stock_v3");
      if (!s || s.day !== day) { s = { day: day, base: 37 + Math.floor(Math.random() * 6), jitter: Math.floor(Math.random() * 3) }; store.set("mv_stock_v3", s); }
      var hrs = new Date().getHours() + new Date().getMinutes() / 60;
      var n = Math.max(9, Math.round(s.base - hrs * 1.15 - s.jitter));
      stockEls.forEach(function (e) { e.textContent = n; });
    }
    var shipEls = doc.querySelectorAll("[data-mv-ship]");
    if (shipEls.length) {
      var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      function fmt(d) { return DAY[d.getDay()] + " " + d.getDate() + " " + MON[d.getMonth()]; }
      function range(a, b) { return a.getMonth() === b.getMonth() ? DAY[a.getDay()] + " " + a.getDate() + "–" + DAY[b.getDay()] + " " + b.getDate() + " " + MON[a.getMonth()] : fmt(a) + " – " + fmt(b); }
      function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
      function nextWorking(d) { var x = addDays(d, 1); while (x.getDay() === 0 || x.getDay() === 6) x = addDays(x, 1); return x; }
      function addBiz(d, n) { var x = new Date(d); while (n > 0) { x = addDays(x, 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
      function paintShip() {
        var now = new Date(), ship1 = addBiz(now, 1), ship2 = addBiz(now, 2), del1 = addBiz(ship1, 3), del2 = addBiz(ship2, 6);
        shipEls.forEach(function (e) { e.textContent = "Ships within 48 hours \u00b7 free tracked shipping"; });
        doc.querySelectorAll("[data-ship-d0]").forEach(function (e) { e.textContent = fmt(now); });
        doc.querySelectorAll("[data-ship-d1]").forEach(function (e) { e.textContent = range(ship1, ship2); });
        doc.querySelectorAll("[data-ship-d2]").forEach(function (e) { e.textContent = range(del1, del2); });
      }
      paintShip(); setInterval(paintShip, 30000);
      doc.querySelectorAll(".mv-shipline .step").forEach(function (el, k) { el.style.setProperty("--i", k); });
    }
  }

  /* ------------------------------------------------------------ count-up */
  function initCountUp() {
    var els = doc.querySelectorAll("[data-mv-count]"); if (!els.length || reduced) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return; io.unobserve(x.target);
        var el = x.target, end = parseFloat(el.getAttribute("data-mv-count")), dec = (el.getAttribute("data-dec") | 0), suf = el.getAttribute("data-suf") || "", t0 = null, dur = 1400;
        function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = (dec === 0 ? Math.round(end * e).toLocaleString("en-GB") : (end * e).toFixed(dec)) + suf; if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* --------------------------------------------------- social-proof toast */
  function initToast() {
    var t = doc.getElementById("mv-toast"); if (!t) return;
    var data = win.MV_TOAST || {}; var names = data.names || [], towns = data.towns || [], img = data.image || "";
    if (!names.length) return;
    if (store.get("mv_toast_off")) return;
    var nameEl = t.querySelector("[data-t-name]"), subEl = t.querySelector("[data-t-sub]"), im = t.querySelector("img");
    if (im && img) im.src = img;
    var bundles = [["1x IRIA GLOW Mask", 3], ["BOGO deal", 7], ["Face Bundle", 5], ["Ultimate Kit", 6]];
    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
    function show() {
      var b = []; bundles.forEach(function (x) { for (var i = 0; i < x[1]; i++) b.push(x[0]); });
      var mins = 2 + Math.floor(Math.random() * 55);
      nameEl.textContent = pick(names) + " from " + pick(towns);
      subEl.innerHTML = "bought <em>" + pick(b) + "</em> · " + (mins < 60 ? mins + " min ago" : "1 hr ago");
      t.classList.add("is-show");
      setTimeout(function () { t.classList.remove("is-show"); }, 6500);
    }
    t.querySelector("button").addEventListener("click", function () { t.classList.remove("is-show"); store.set("mv_toast_off", 1); });
    setTimeout(function () { show(); setInterval(function () { if (doc.visibilityState === "visible") show(); }, 28000 + Math.random() * 12000); }, 11000);
  }

  /* ------------------------------------------- sign-up forms (code reveal) */
  /* Any form[data-mv-signup] posts to /contact in a hidden iframe so the page never reloads,
     then swaps to the success state showing the code. */
  function initSignup() {
    var forms = doc.querySelectorAll("form[data-mv-signup]"); if (!forms.length) return;
    var ifr = doc.getElementById("mv-signup-frame");
    if (!ifr) { ifr = doc.createElement("iframe"); ifr.id = "mv-signup-frame"; ifr.name = "mv-signup-frame"; ifr.style.cssText = "position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none"; ifr.setAttribute("aria-hidden", "true"); ifr.tabIndex = -1; doc.body.appendChild(ifr); }
    forms.forEach(function (f) {
      f.setAttribute("target", "mv-signup-frame");
      f.addEventListener("submit", function () {
        var email = f.querySelector("input[type=email]"); if (!email || !email.value) return;
        var box = f.closest("[data-mv-signup-box]") || f.parentNode;
        setTimeout(function () { box.classList.add("is-done"); store.set("mv_signed", { at: Date.now(), e: email.value }); }, 350);
      });
    });
    doc.querySelectorAll("[data-mv-copy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var code = b.getAttribute("data-mv-copy");
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { var o = b.textContent; b.textContent = "Copied!"; setTimeout(function () { b.textContent = o; }, 1600); });
      });
    });
  }

  /* --------------------------------------------------------------- quiz */
  function initQuiz() {
    var Q = win.MV_QUIZ; var ov = doc.getElementById("mvq-overlay"), box = doc.getElementById("mvq"); if (!Q || !ov || !box) return;
    var KEY = "mvq_state_v2", st = store.get(KEY) || {}, now = Date.now();
    var stage = doc.getElementById("mvq-stage"), prog = doc.getElementById("mvq-prog"), progWrap = doc.getElementById("mvq-prog-wrap"), title = doc.getElementById("mvq-title"), kick = doc.getElementById("mvq-kick");
    var picks = [], step = 0, opened = false, lastFocus = null;
    var esc = function (s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;"); };
    var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

    function renderQ() {
      var q = Q.questions[step];
      prog.style.width = Math.max(8, step / Q.questions.length * 100) + "%";
      kick.textContent = Q.kicker; title.textContent = Q.title;
      var h = '<p class="mvq-step">Question ' + (step + 1) + ' of ' + Q.questions.length + '</p><p class="mvq-q">' + esc(q.q) + '</p>';
      q.o.forEach(function (o) { h += '<button type="button" class="mvq-opt" data-t="' + esc(o[1]) + '"><i></i><span>' + esc(o[0]) + '</span></button>'; });
      h += '<button type="button" class="mvq-skip" id="mvq-later">' + esc(Q.skip) + '</button>';
      stage.innerHTML = h;
      stage.querySelectorAll(".mvq-opt").forEach(function (b) {
        b.addEventListener("click", function () {
          b.classList.add("is-picked"); picks.push(b.getAttribute("data-t")); step++;
          setTimeout(function () { if (step < Q.questions.length) renderQ(); else renderResult(); }, 260);
        });
      });
      doc.getElementById("mvq-later").addEventListener("click", snooze);
      var first = stage.querySelector(".mvq-opt"); if (first) first.focus();
    }
    function has(t) { return picks.indexOf(t) >= 0; }
    function renderResult() {
      prog.style.width = "100%"; progWrap.style.opacity = ".35";
      kick.textContent = Q.resultKicker; title.textContent = Q.resultTitle;
      var pains = [];
      if (has("night")) pains.push(Q.pains.night);
      if (has("legs") || has("wantcalm")) pains.push(Q.pains.legs);
      if (has("mind")) pains.push(Q.pains.mind);
      if (has("empty") || has("allday") || has("crash")) pains.push(Q.pains.empty);
      if (has("wired")) pains.push(Q.pains.wired);
      if (has("day")) pains.push(Q.pains.day);
      var why = has("failed") ? Q.whyFailed : has("first") ? Q.whyFirst : Q.whyDefault;
      var extra = (has("stomach") ? " " + Q.gentle : "") + (has("pills") ? " " + Q.pills : "");
      var lead = has("day") && !has("night") && !has("legs") && !has("mind") ? Q.leadDay : Q.leadNight;
      var h = '<span class="mvq-res-badge">' + ICON + ' ' + esc(Q.badge) + '</span>';
      if (pains.length) { h += '<ul class="mvq-pains">'; pains.slice(0, 3).forEach(function (p) { h += '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg><span>' + esc(p) + '</span></li>'; }); h += '</ul>'; }
      h += '<p class="mvq-res-p">' + lead + '</p><p class="mvq-res-p">' + why + extra + '</p><p class="mvq-res-p">' + Q.claims + '</p><p class="mvq-res-p"><b>' + esc(Q.guarantee) + '</b></p>';
      h += '<div id="mvq-offer"><p class="mvq-timer">' + esc(Q.offerLine) + '</p>'
        + '<form method="post" action="/contact#mvq" accept-charset="UTF-8" data-mv-signup id="mvq-form"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,quiz,iria">'
        + '<input class="mvq-email" type="email" name="contact[email]" placeholder="' + esc(Q.emailPlaceholder) + '" required autocomplete="email">'
        + '<button class="mvq-cta" type="submit">' + esc(Q.emailCta) + '</button></form>'
        + '<a class="mvq-cta2" href="' + esc(Q.productUrl) + '">' + esc(Q.noThanks) + '</a></div>'
        + '<p class="mvq-small">' + esc(Q.small) + '</p>';
      stage.innerHTML = h;
      store.set(KEY, { done: true, at: now, picks: picks });
      var f = doc.getElementById("mvq-form");
      f.addEventListener("submit", function () {
        var email = f.querySelector("input[type=email]"); if (!email.value) return;
        setTimeout(function () {
          doc.getElementById("mvq-offer").innerHTML = '<div class="mvq-code"><small>' + esc(Q.codeLabel) + '</small><b>' + esc(Q.code) + '</b></div>'
            + '<a class="mvq-cta" href="/discount/' + encodeURIComponent(Q.code) + '?redirect=' + encodeURIComponent(Q.productUrl) + '">' + ICON + ' ' + esc(Q.claimCta) + '</a>'
            + '<button type="button" class="mvq-cta2" data-mv-copy="' + esc(Q.code) + '">' + esc(Q.copyLabel) + '</button>';
          initSignup();
        }, 350);
      });
      initSignup();
    }
    function open(reason) {
      if (opened) return;
      if (reason !== "manual") {
        var st2 = store.get(KEY) || {};
        if (st2.done || (st2.snoozeUntil && Date.now() < st2.snoozeUntil) || st2.shownThisLoad) return;
      }
      var st3 = store.get(KEY) || {}; st3.shownThisLoad = true; /* in-memory only */
      opened = true; lastFocus = doc.activeElement;
      ov.hidden = false; box.hidden = false;
      requestAnimationFrame(function () { ov.classList.add("is-show"); box.classList.add("is-show"); });
      renderQ(); store.set(KEY, Object.assign({}, st, { shownAt: now, reason: reason }));
    }
    function close() { ov.classList.remove("is-show"); box.classList.remove("is-show"); setTimeout(function () { ov.hidden = true; box.hidden = true; }, 380); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    function snooze() { var s = store.get(KEY) || {}; s.snoozeUntil = Date.now() + (Q.snoozeDays || 3) * 86400000; store.set(KEY, s); close(); /* opened stays true: one auto-show per page */ }
    doc.getElementById("mvq-x").addEventListener("click", function () { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); });
    ov.addEventListener("click", function () { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); });
    doc.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); } });
    /* manual triggers always work, even after snooze/done */
    doc.querySelectorAll("[data-mv-quiz-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); picks = []; step = 0; opened = false; progWrap.style.opacity = "1"; open("manual"); }); });
    var forced = /[?&]mvq=1/.test(location.search);
    if (!forced && (st.done || (st.snoozeUntil && now < st.snoozeUntil))) return;
    var delay = forced ? 300 : (Q.delayMs || 20000);
    setTimeout(function () { open("timer"); }, delay);
    /* exit intent (desktop): cursor leaves through the top edge */
    if (Q.exitIntent !== false) {
      var armed = false, exitShown = false; setTimeout(function () { armed = true; }, 6000);
      doc.addEventListener("mouseout", function (e) {
        if (!armed || opened || exitShown) return;
        var st4 = store.get(KEY) || {};
        if (st4.done || (st4.snoozeUntil && Date.now() < st4.snoozeUntil)) return;
        if (!e.relatedTarget && e.clientY <= 0) { exitShown = true; open("exit"); }
      });
    }
  }

  /* ---------------------------------------------- sticky-bar timer mirror */
  function initStickyTimer() {
    var t = doc.querySelector("[data-mv-sticky-timer]"); if (!t) return;
    var s = cdState();
    function paint() {
      var left = s.end - Date.now();
      if (left <= 0) { t.textContent = "Extended for you"; t.classList.add("is-extended"); return; }
      t.classList.remove("is-extended");
      var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), sec = Math.floor(left % 60000 / 1000);
      t.textContent = "ends in " + (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(sec);
    }
    paint(); setInterval(function () { s = cdState(); paint(); }, 1000);
  }

  /* ------------------------------------------------ active footer links */
  function initActiveLinks() {
    var p = location.pathname.replace(/\/$/, "") || "/";
    doc.querySelectorAll(".mv-foot__col a").forEach(function (a) { var h = (a.getAttribute("href") || "").replace(/\/$/, "") || "/"; if (h === p) a.classList.add("is-active"); });
  }


  /* ------------------------------------------------- v5: marquee, explorers, motion */
  function initMarquee() {
    doc.querySelectorAll("[data-mv-marquee]").forEach(function (m) {
      m.addEventListener("touchstart", function () { m.classList.add("is-paused"); }, { passive: true });
      m.addEventListener("touchend", function () { setTimeout(function () { m.classList.remove("is-paused"); }, 3500); });
    });
  }
  function initForms() {
    doc.querySelectorAll("[data-mv-forms]").forEach(function (w) {
      var chips = w.querySelectorAll(".mv-forms__chip"), items = w.querySelectorAll(".mv-forms__item"), bar = w.querySelector(".mv-forms__bar i"),
          cycle = +(w.getAttribute("data-cycle") || 0), i = 0, timer, user = false;
      function show(k) {
        i = (k + chips.length) % chips.length;
        chips.forEach(function (c, j) { c.classList.toggle("is-on", j === i); c.setAttribute("aria-selected", j === i ? "true" : "false"); });
        items.forEach(function (it, j) { it.classList.toggle("is-on", j === i); });
        if (bar) { bar.style.transition = "none"; bar.style.width = "0"; void bar.offsetWidth; if (cycle && !user && !reduced) { bar.style.transition = "width " + cycle + "ms linear"; bar.style.width = "100%"; } }
      }
      function loop() { if (!cycle || user || reduced) return; clearTimeout(timer); timer = setTimeout(function () { if (doc.visibilityState === "visible") show(i + 1); loop(); }, cycle); }
      chips.forEach(function (c, k) { c.addEventListener("click", function () { user = true; clearTimeout(timer); show(k); }); });
      if ("IntersectionObserver" in win) { var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { show(i); loop(); io.disconnect(); } }); }, { threshold: 0.3 }); io.observe(w); } else { show(0); }
    });
  }
  function initSym() {
    doc.querySelectorAll("[data-mv-sym]").forEach(function (w) {
      var chips = w.querySelectorAll(".mv-sym__chip"), items = w.querySelectorAll(".mv-sym__item");
      chips.forEach(function (c, k) { c.addEventListener("click", function () {
        chips.forEach(function (x, j) { x.classList.toggle("is-on", j === k); x.setAttribute("aria-selected", j === k ? "true" : "false"); });
        items.forEach(function (it, j) { it.classList.toggle("is-on", j === k); });
      }); });
    });
  }
  function initTilt() {
    if (reduced || !(win.matchMedia && win.matchMedia("(hover:hover)").matches)) return;
    doc.querySelectorAll(".mv-tilt, .mv-bcard, .quantity-break, .mv-step").forEach(function (el) {
      el.addEventListener("pointermove", function (e) { var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5; el.style.transform = "perspective(700px) rotateX(" + (-y * 6).toFixed(2) + "deg) rotateY(" + (x * 6).toFixed(2) + "deg) translateY(-2px)"; });
      el.addEventListener("pointerleave", function () { el.style.transform = ""; });
    });
  }
  function initRipple() {
    if (reduced) return;
    doc.addEventListener("click", function (e) {
      var b = e.target.closest(".mv-btn, .product-form__submit, .atc-button"); if (!b) return;
      var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height), sp = doc.createElement("span"); sp.className = "mv-ripple";
      sp.style.cssText = "width:" + s + "px;height:" + s + "px;left:" + (e.clientX - r.left - s / 2) + "px;top:" + (e.clientY - r.top - s / 2) + "px";
      b.appendChild(sp); setTimeout(function () { sp.remove(); }, 650);
    });
  }
  function initProgress() {
    var bar = doc.createElement("div"); bar.className = "mv-progress"; doc.body.appendChild(bar);
    function paint() { var h = doc.documentElement.scrollHeight - win.innerHeight; bar.style.width = (h > 0 ? Math.min(100, win.scrollY / h * 100) : 0) + "%"; }
    win.addEventListener("scroll", paint, { passive: true }); paint();
  }

  /* ------------------------------------------------- v6 motion */
  function initSplit() {
    var h = doc.querySelector(".mv-hero__h1"); if (!h || reduced || h.getAttribute("data-split")) return;
    h.setAttribute("data-split", "1"); var i = 0, out = doc.createDocumentFragment();
    function wrap(txt, cls) { var w = doc.createElement("span"); w.className = "w"; var s = doc.createElement("span"); s.style.setProperty("--i", i++); if (cls) s.className = cls; s.textContent = txt; w.appendChild(s); return w; }
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) { n.textContent.split(/(\s+)/).forEach(function (t) { if (!t) return; if (/^\s+$/.test(t)) out.appendChild(doc.createTextNode(" ")); else out.appendChild(wrap(t)); }); }
      else if (n.nodeType === 1) { var em = n.cloneNode(false); em.appendChild(wrap(n.textContent)); out.appendChild(em); out.appendChild(doc.createTextNode(" ")); }
    });
    h.innerHTML = ""; h.appendChild(out);
  }
  function initMagnet() { /* disabled — cursor-follow on buttons read as vibration */ }

  function initParallax() {
    if (reduced || win.innerWidth < 900) return;
    var els = doc.querySelectorAll(".mv-forms__media img, .mv-auth__media img, .mv-offer__img img, .mv-step__media, .bbmt-media img, .bbcz-media img");
    if (!els.length) return; els.forEach(function (e) { e.setAttribute("data-mv-parallax", "1"); });
    var ticking = false;
    function paint() { ticking = false; var vh = win.innerHeight; els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var c = (r.top + r.height / 2 - vh / 2) / vh; e.style.transform = "translateY(" + (-c * 22).toFixed(1) + "px)"; }); }
    win.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true }); paint();
  }
  function initGlow() {
    if (reduced || !(win.matchMedia && win.matchMedia("(hover:hover)").matches)) return;
    doc.querySelectorAll(".mv-offer").forEach(function (s) {
      s.addEventListener("pointermove", function (e) { var r = s.getBoundingClientRect(); s.style.setProperty("--mx", (e.clientX - r.left) + "px"); s.style.setProperty("--my", (e.clientY - r.top) + "px"); s.classList.add("is-hover"); });
      s.addEventListener("pointerleave", function () { s.classList.remove("is-hover"); });
    });
  }
  function initHeaderScroll() {
    function paint() { root.classList.toggle("mv-scrolled", win.scrollY > 24); }
    win.addEventListener("scroll", paint, { passive: true }); paint();
  }
  function initPricePop() {
    doc.addEventListener("mv:bundle", function (e) { var p = e.target.querySelector("[data-mv-atc-price]"); if (!p) return; p.classList.remove("mv-pop"); void p.offsetWidth; p.classList.add("mv-pop"); });
  }
  function initIndexVars() {
    doc.querySelectorAll(".mv-benefits li, .mv-chiprow span, .mv-stats__grid li, .bbrv-row, .mv-foot__col").forEach(function (el) { var k = Array.prototype.indexOf.call(el.parentNode.children, el); el.style.setProperty("--i", k); });
    doc.querySelectorAll(".mv-benefits .ic svg, .mv-chiprow svg").forEach(function (el, k) { el.style.setProperty("--i", k % 4); });
  }

  /* ------------------------------------------------- shipping protection toggle */
  function initProtect() {
    var all = doc.querySelectorAll("[data-mv-protect]"); if (!all.length) return;
    var groups = {};
    all.forEach(function (e) { var v = e.getAttribute("data-variant"); if (v) (groups[v] = groups[v] || []).push(e); });
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      Object.keys(groups).forEach(function (v) {
        var has = c.items.some(function (i) { return String(i.variant_id) === String(v); });
        groups[v].forEach(function (e) { e.querySelector("input").checked = has; e.classList.toggle("is-on", has); });
      });
    }).catch(function () {});
    Object.keys(groups).forEach(function (vid) {
    var els = groups[vid];
    els.forEach(function (el) {
      var busy = false;
      el.querySelector("input").addEventListener("change", function (ev) {
        if (busy) { ev.preventDefault(); return; } busy = true;
        var on = ev.target.checked;
        els.forEach(function (e) { e.classList.toggle("is-on", on); e.querySelector("input").checked = on; });
        var done = function () { busy = false; if (el.getAttribute("data-reload")) location.reload(); };
        if (on) fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: +vid, quantity: 1 }) }).then(done, done);
        else fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: vid, quantity: 0 }) }).then(done, done);
      });
    });
    });
  }

  /* --------------------------------------- "Offer" line-item property (shows the deal at checkout) */
  function offerText(title, price, compare) {
    price = +price; compare = +compare;
    if (!compare || compare <= price) return "";
    var save = ((compare - price) / 100), pct = Math.round(100 - price * 100 / compare);
    var deal = /\(([^)]+)\)/.exec(title || "");
    return (deal ? deal[1] + " — " : "") + "you save " + money(compare - price) + " (" + pct + "% off)";
  }




  ready(function () {
    initIndexVars(); initReveal(); initBundles(); initCarousel(); initUrgency(); initCountUp(); initSignup(); initActiveLinks(); initMarquee(); initForms(); initSym(); initHeaderScroll(); initPricePop(); initProtect();
  });
  doc.addEventListener("shopify:section:load", function () { initBundles(); initCarousel(); initCountdown(); initSignup(); initForms(); initSym(); initMarquee(); });
})();
